module.exports = __webpack_public_path__ + "static/img/数据维护@4x.57817675.png";